import axios from "axios";

// export const API = axios.create({
//   baseURL: "https://examwebsiteapi.nuhvin.com",
// });

// export const APIURL = "https://examwebsiteapi.nuhvin.com";

export const API = axios.create({
  baseURL: "https://examwebsiteapi.nuhvin.com",
});

export const APIURL = "https://examwebsiteapi.nuhvin.com";
